export const REQUEST_TYPES = {
  QUOTE: "cotizacion",
  CONTACT: "contacto",
};

export const REQUEST_STATUS = {
  PENDING: "pendiente",
  IN_PROGRESS: "en_curso",
  CLOSED: "cerrado",
};

export const API_ENDPOINTS = {
  PRODUCTS: "/api/products",
  REQUESTS: "/api/requests",
};

export const STATUS_LABELS = {
  [REQUEST_STATUS.PENDING]: "Pendiente",
  [REQUEST_STATUS.IN_PROGRESS]: "En Curso",
  [REQUEST_STATUS.CLOSED]: "Cerrado",
};

export const TYPE_LABELS = {
  [REQUEST_TYPES.QUOTE]: "Cotización",
  [REQUEST_TYPES.CONTACT]: "Contacto",
};

export const locations = [
  {
    name: "Santiago",
    city: "Santiago",
    address: "Camino longitudinal Ruta 5 Sur 02535, Buin",
    coordinates: { lat: -33.7027027, lng: -70.7228771 },
    embedRef:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.2413706527195!2d-70.72287709999999!3d-33.70270269999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9663219a392a8119%3A0x6e492a61196ff4a5!2sTattersall%20Venta%20usados!5e0!3m2!1ses!2scl!4v1761157323856!5m2!1ses!2scl",
    googleRef: "https://maps.app.goo.gl/4uAAs7pFooVcYzGN6",
    wazeRef:
      "https://ul.waze.com/ul?venue_id=189597111.1895840038.40249517&overview=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location",
  },
];

// Re-export contact information
export * from "./contactInfo";
